import React, { Component } from 'react';
import './App.css';
import { Row, Col, Accordion, Card, Container, Button, Form, Popover, OverlayTrigger, ListGroup } from 'react-bootstrap';
import Data from './Data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as ObjectiveIcon } from './Icons/ObjectiveIcon.svg';
import { ReactComponent as BoxDelivery } from './Icons/BoxDelivery.svg';
import { ReactComponent as ParcelPostInsurance } from './Icons/ParcelPostInsurance.svg';
import { ReactComponent as FastDelivery } from './Icons/FastDelivery.svg';
import Moment from 'react-moment';
import moment from 'moment'

const WAIT_INTERVAL = 1000;

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const filterObjective = (item) => {
  return typeof item.Objetivodasolicitação === 'string' ? capitalize(item.Objetivodasolicitação.toLowerCase()) : item.Objetivodasolicitação
};

export default class App extends Component {
  state = {
    quarterOneFiltered: [],
    quarterTwoFiltered: [],
    quarterThreeFiltered: [],
    quarterFourFiltered: [],
    quarterOneGoals: [],
    quarterTwoGoals:[],
    quarterThreeGoals: [],
    quarterFourGoals: [],
    quarterOneGoalsFiltered: [],
    quarterTwoGoalsFiltered:[],
    quarterThreeGoalsFiltered: [],
    quarterFourGoalsFiltered: [],
    quarterOne: [],
    quarterTwo: [],
    quarterThree: [],
    quarterFour: [],
    remaining: [],
    remainingFiltered: [],
    filteredObjective: [],
    objective: null,
    isToggleOn: true,
    value: '',
    viewType: 0
  };

  constructor(props) {
    super(props);
    this.actionClick = this.actionClick.bind(this);
    this.textInput = React.createRef();
  }

  componentDidMount() {
    this.loadData();

    this.timer = null;
  }

  loadData = async () => {
    return Data().then(res => {
      res.forEach(item => {
        Object.keys(item).forEach(function (key) {
          var replaced = key.replace(/\s/g, '');
          if (key !== replaced) {
            item[replaced] = item[key];
            delete item[key];
          }
        });
      });

      var quarterOne = [];
      var quarterTwo = [];
      var quarterThree = [];
      var quarterFour = [];
      var remaining = [];
      res.forEach(item => {
        if (item.IterationPath === '\\Produtos\\2020-Q1')
          quarterOne.push(item);
        else if (item.IterationPath === '\\Produtos\\2020-Q2')
          quarterTwo.push(item);
        else if (item.IterationPath === '\\Produtos\\2020-Q3')
          quarterThree.push(item);
        else if (item.IterationPath === '\\Produtos\\2020-Q4')
          quarterFour.push(item);
        else
          remaining.push(item);
      });

      var quarterOneGoals = [...new Set(quarterOne.map(item => filterObjective(item)))].filter(n => n);
      var quarterTwoGoals = [...new Set(quarterTwo.map(item => filterObjective(item)))].filter(n => n);
      var quarterThreeGoals = [...new Set(quarterThree.map(item => filterObjective(item)))].filter(n => n);
      var quarterFourGoals = [...new Set(quarterFour.map(item => filterObjective(item)))].filter(n => n);

      var objective = [...quarterOneGoals, ...quarterTwoGoals, ...quarterThreeGoals, ...quarterFourGoals];

      this.setState({
        quarterOne: quarterOne,
        quarterTwo: quarterTwo,
        quarterThree: quarterThree,
        quarterFour: quarterFour,
        quarterOneFiltered: quarterOne,
        quarterTwoFiltered: quarterTwo,
        quarterThreeFiltered: quarterThree,
        quarterFourFiltered: quarterFour,
        remaining: remaining,
        remainingFiltered: remaining,
        filteredObjective: [...new Set(objective)],
        quarterOneGoals: quarterOneGoals,
        quarterTwoGoals :quarterTwoGoals,
        quarterThreeGoals: quarterThreeGoals,
        quarterFourGoals: quarterFourGoals,
        quarterOneGoalsFiltered: quarterOneGoals,
        quarterTwoGoalsFiltered: quarterTwoGoals,
        quarterThreeGoalsFiltered: quarterThreeGoals,
        quarterFourGoalsFiltered: quarterFourGoals
      });

    }).catch(err => console.log(err));
  };

  actionClick() {
    this.setState(state => ({
      isToggleOn: !state.isToggleOn
    }));
  }

  selectWorkItemByObjective(workItem, objective) {
    return filterObjective(workItem) === objective;
  }

  select(objective) {
    if (this.state.objective !== objective) {
      this.setState(state => ({
        quarterOneFiltered: state.quarterOne.filter(x => this.selectWorkItemByObjective(x, objective)),
        quarterTwoFiltered: state.quarterTwo.filter(x => this.selectWorkItemByObjective(x, objective)),
        quarterThreeFiltered: state.quarterThree.filter(x => this.selectWorkItemByObjective(x, objective)),
        quarterFourFiltered: state.quarterFour.filter(x => this.selectWorkItemByObjective(x, objective)),
        objective: objective
      }));
    } else {
      this.setState(state => ({
        quarterOneFiltered: state.quarterOne,
        quarterTwoFiltered: state.quarterTwo,
        quarterThreeFiltered: state.quarterThree,
        quarterFourFiltered: state.quarterFour,
        objective: null
      }));
    }
  }

  filterKeyword(workItem, keyword) {
    return Object.keys(workItem).some(function (key) {
      if (key === "ID" || key === "TargetDate")
        return workItem[key] == keyword;
      return workItem[key].toUpperCase().includes(keyword);
    })
  }

  handleChange() {
    var value = this.textInput.current.value.toUpperCase();

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      var qOneGoalsFiltered = this.state.quarterOneGoals.filter(x => x.toUpperCase().includes(value));
      var qTwoGoalsFiltered = this.state.quarterTwoGoals.filter(x => x.toUpperCase().includes(value));
      var qThreeGoalsFiltered = this.state.quarterThreeGoals.filter(x => x.toUpperCase().includes(value));
      var qFourGoalsFiltered = this.state.quarterFourGoals.filter(x => x.toUpperCase().includes(value));

      var qOneFiltered = this.state.quarterOne.filter(x => this.filterKeyword(x, value));
      var qTwoFiltered = this.state.quarterTwo.filter(x => this.filterKeyword(x, value));
      var qThreeFiltered = this.state.quarterThree.filter(x => this.filterKeyword(x, value));
      var qFourFiltered = this.state.quarterFour.filter(x => this.filterKeyword(x, value));
      var remainingFiltered = this.state.remaining.filter(x => this.filterKeyword(x, value));

      this.setState({
        quarterOneFiltered: qOneFiltered,
        quarterTwoFiltered: qTwoFiltered,
        quarterThreeFiltered: qThreeFiltered,
        quarterFourFiltered: qFourFiltered,
        quarterOneGoalsFiltered: qOneGoalsFiltered,
        quarterTwoGoalsFiltered: qTwoGoalsFiltered,
        quarterThreeGoalsFiltered: qThreeGoalsFiltered,
        quarterFourGoalsFiltered: qFourGoalsFiltered,
        remainingFiltered: remainingFiltered
      });
    }, WAIT_INTERVAL);
  }

  lastModificationDate = () => {
    var file = new File(['./Data.xlsx'], 'Data.xlsx');
    return new Date(file.lastModified);
  }

  getInitialQuarterData(quarter) {
    return moment('2019-10-01', 'YYYY-MM-DD').add(quarter, 'quarter');
  }

  quarterIcon(quarter) {
    var now = moment();

    var startQuarter = this.getInitialQuarterData(quarter);
    var endQuarter = moment(startQuarter).add(1, 'quarter').subtract(1, 'day');

    if (now.isAfter(endQuarter))
      return this.delivered;

    if (now.isBetween(startQuarter, endQuarter))
      return this.do;

    if (now.isBefore(startQuarter))
      return this.toDo;
  }

  updateView = (type) => {
    if (type !== this.state.viewType)
      this.setState({viewType: type});


  }

  popover = (
    <Popover id="popover-basic">
      <Popover.Title as="h3">Roadmap - nddFrete</Popover.Title>
      <Popover.Content>
        <strong>Última atualização:</strong>
        <br />
        <Moment format="DD/MM/YYYY HH:mm">
          {this.lastModificationDate()}
        </Moment>
        <br />
        <br />
        <h6>nddfrete.produtos@ndd.com.br</h6>
      </Popover.Content>
    </Popover>
  );

  delivered = (
    <ParcelPostInsurance height="40px" />
  )

  do = (
    <FastDelivery height="40px" />
  )

  toDo = (
    <BoxDelivery height="40px" />
  )

  render() {
    return (
      <div className="App">
        <div className="header" >
          <div>
            <Button className="button-to-link" variant="link" onClick={this.actionClick} >
              <FontAwesomeIcon icon={faBars} size="lg" />
            </Button>
            <img className="content-image" src="./logo.png" alt="logo" />
          </div>

          <div className="right-header-bar" >
            <Container fluid >
              <Row>
                <Col md={4}>
                  <Row style={{paddingTop: "14px", fontSize: "small" }}>
                    <Col style={{ padding: "0", textAlign: "center", borderRight: "1px solid #ccc"}}>
                      <Button className="view-button" 
                        style={{fontWeight: this.state.viewType === 0 ? 'bold' : 'normal'}} 
                        size="sm" variant="link" 
                        onClick={() => this.updateView(0)}
                        block
                      >Por demanda</Button> 
                    </Col>
                    <Col style={{ padding: "0", textAlign: "center", borderLeft: "1px solid #ccc" }}>
                      <Button className="view-button" 
                        style={{fontWeight: this.state.viewType === 1 ? 'bold' : 'normal'}} 
                        size="sm" variant="link"
                        onClick={() => this.updateView(1)}
                        block
                      >Por objetivo</Button> 
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Form.Group style={{ height: "100%", marginBottom: "0px" }}>
                    <Form.Control className="filter-field"
                      type="text"
                      ref={this.textInput}
                      placeholder="Pesquisar"
                      onChange={() => this.handleChange()} />
                  </Form.Group>
                </Col>
                <Col md={1}>
                  <div className="row justify-content-center" style={{ margin: "0 10px 0 0" }} >
                    <OverlayTrigger trigger="click" placement="bottom" overlay={this.popover}>
                      <Button className="button-to-link" variant="link" >
                        <FontAwesomeIcon icon={faQuestionCircle} size="lg" />
                      </Button>
                    </OverlayTrigger>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <div style={{ width: this.state.isToggleOn && this.state.viewType === 0 ? "250px" : "0" }} className="sidebar">
          <div>
            <div className="row justify-content-center header-sidebar">
              <ObjectiveIcon fill="white" width="30px" height="30px" />
              <h5>Objetivos</h5>
            </div>
            {this.state.filteredObjective.map((item, index) => (
              <div className="objective-item-sidebar" style={{ borderBottom: "solid 1px #c5c5c5" }} key={index}>
                <Button variant="light" block onClick={() => this.select(item)}>
                  {item}
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginLeft: this.state.isToggleOn && this.state.viewType === 0 ? "250px" : "0", marginRight: !this.state.isToggleOn ? "250px" : "0" }} className="main-content" >
          <Container fluid >
            <Row>
              <Col>
                <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                  <Col>
                    <div className="row justify-content-center" style={{ marginBottom: "10px" }} >
                      {this.quarterIcon(1)}
                    </div>
                    <Card style={{ background: "#f7f7f7", borderBottom: "0" }}>
                      <div className="row justify-content-center">
                        <span className="quarter-title" >Q1 - 2020</span>
                      </div>
                    </Card>
                    <Accordion style={{display: this.state.viewType === 0 ? 'block' : 'none'}} className="quarterOne-list">
                      {this.state.quarterOneFiltered.map(item => (
                        <Card key={item.ID}>
                          <Accordion.Toggle style={{ cursor: 'pointer' }} as={Card.Header} eventKey={item.ID}>
                            {item.Title}
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={item.ID}>
                            <Card.Body>
                              <Row className="line-detail" >
                                <Col><span>ID</span><br />{item.ID}</Col><Col><span>Cliente</span><br />{item.NomedoCliente}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Classificação</span><br />{item.ClassificaçãodaDemanda}</Col><Col><span>Tema</span><br />{item.NomedoTema}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Tags</span><br />{item.Tags}</Col>
                              </Row>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      ))}
                    </Accordion>

                    <Card style={{display: this.state.viewType === 1 ? 'block' : 'none'}}>
                      <ListGroup variant="flush">
                        {this.state.quarterOneGoalsFiltered.map((item, index) => (
                          <ListGroup.Item key={index} >{item}</ListGroup.Item>
                        ))}
                      </ListGroup>
                    </Card>
                  </Col>

                  <Col>
                    <div className="row justify-content-center" style={{ marginBottom: "10px" }}>
                      {this.quarterIcon(2)}
                    </div>
                    <Card style={{ background: "#f7f7f7", borderBottom: "0" }}>
                      <div className="row justify-content-center">
                        <span className="quarter-title" >Q2 - 2020</span>
                      </div>
                    </Card>
                    <Accordion style={{display: this.state.viewType === 0 ? 'block' : 'none'}} className="quarterTwo-list">
                      {this.state.quarterTwoFiltered.map(item => (
                        <Card key={item.ID}>
                          <Accordion.Toggle style={{ cursor: 'pointer' }} as={Card.Header} eventKey={item.ID}>
                            {item.Title}
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={item.ID}>
                            <Card.Body>
                              <Row className="line-detail" >
                                <Col><span>ID</span><br />{item.ID}</Col><Col><span>Cliente</span><br />{item.NomedoCliente}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Classificação</span><br />{item.ClassificaçãodaDemanda}</Col><Col><span>Tema</span><br />{item.NomedoTema}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Tags</span><br />{item.Tags}</Col>
                              </Row>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      ))}
                    </Accordion>

                    <Card style={{display: this.state.viewType === 1 ? 'block' : 'none'}}>
                      <ListGroup variant="flush">
                        {this.state.quarterTwoGoalsFiltered.map((item, index) => (
                          <ListGroup.Item key={index} >{item}</ListGroup.Item>
                        ))}
                      </ListGroup>
                    </Card>
                  </Col>

                  <Col>
                    <div className="row justify-content-center" style={{ marginBottom: "10px" }}>
                      {this.quarterIcon(3)}
                    </div>
                    <Card style={{ background: "#f7f7f7", borderBottom: "0" }}>
                      <div className="row justify-content-center">
                        <span className="quarter-title" >Q3 - 2020</span>
                      </div>
                    </Card>
                    <Accordion style={{display: this.state.viewType === 0 ? 'block' : 'none'}} className="quarterThree-list">
                      {this.state.quarterThreeFiltered.map(item => (
                        <Card key={item.ID}>
                          <Accordion.Toggle style={{ cursor: 'pointer' }} as={Card.Header} eventKey={item.ID}>
                            {item.Title}
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={item.ID}>
                            <Card.Body>
                              <Row className="line-detail" >
                                <Col><span>ID</span><br />{item.ID}</Col><Col><span>Cliente</span><br />{item.NomedoCliente}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Classificação</span><br />{item.ClassificaçãodaDemanda}</Col><Col><span>Tema</span><br />{item.NomedoTema}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Tags</span><br />{item.Tags}</Col>
                              </Row>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      ))}
                    </Accordion>

                    <Card style={{display: this.state.viewType === 1 ? 'block' : 'none'}}>
                      <ListGroup variant="flush">
                        {this.state.quarterThreeGoalsFiltered.map((item, index) => (
                          <ListGroup.Item key={index} >{item}</ListGroup.Item>
                        ))}
                      </ListGroup>
                    </Card>
                  </Col>

                  <Col>
                    <div className="row justify-content-center" style={{ marginBottom: "10px" }}>
                      {this.quarterIcon(4)}
                    </div>
                    <Card style={{ background: "#f7f7f7", borderBottom: "0" }}>
                      <div className="row justify-content-center">
                        <span className="quarter-title" >Q4 - 2020</span>
                      </div>
                    </Card>
                    <Accordion style={{display: this.state.viewType === 0 ? 'block' : 'none'}} className="quarterFour-list">
                      {this.state.quarterFourFiltered.map(item => (
                        <Card key={item.ID}>
                          <Accordion.Toggle style={{ cursor: 'pointer' }} as={Card.Header} eventKey={item.ID}>
                            {item.Title}
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={item.ID}>
                            <Card.Body>
                              <Row className="line-detail" >
                                <Col><span>ID</span><br />{item.ID}</Col><Col><span>Cliente</span><br />{item.NomedoCliente}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Classificação</span><br />{item.ClassificaçãodaDemanda}</Col><Col><span>Tema</span><br />{item.NomedoTema}</Col>
                              </Row>
                              <Row className="line-detail" >
                                <Col><span>Tags</span><br />{item.Tags}</Col>
                              </Row>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      ))}
                    </Accordion>

                    <Card style={{display: this.state.viewType === 1 ? 'block' : 'none'}}>
                      <ListGroup variant="flush">
                        {this.state.quarterFourGoalsFiltered.map((item, index) => (
                          <ListGroup.Item key={index} >{item}</ListGroup.Item>
                        ))}
                      </ListGroup>
                    </Card>
                  </Col>
                </Row>

              </Col>

            </Row>
          </Container>
        </div>

        <div style={{ width: !this.state.isToggleOn && this.state.viewType === 0 ? "250px" : "0" }} className="sidebar-other-items" >
          <div>
            <div className="row justify-content-center">
              <h1>...</h1>
            </div>
            <Accordion className="remaining-list">
              {this.state.remainingFiltered.map(item => (
                <Card key={item.ID}>
                  <Accordion.Toggle style={{ cursor: 'pointer' }} as={Card.Header} eventKey={item.ID}>
                    {item.Title}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={item.ID}>
                    <Card.Body>
                      <Row className="line-detail" >
                        <Col><span>ID</span><br />{item.ID}</Col><Col><span>Tema</span><br />{item.NomedoTema}</Col>
                      </Row>
                      <Row className="line-detail" >
                        <Col><span>Classificação</span><br />{item.ClassificaçãodaDemanda}</Col><Col><span>Cliente</span><br />{item.NomedoCliente}</Col>
                      </Row>
                      <Row className="line-detail" >
                        <Col><span>Tags</span><br />{item.Tags}</Col>
                      </Row>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    );
  }
}
